import {
    Typography,
    TypographyProps,
    Button,
    CustomIcon,
    Input,
    Container,
    Separator,
    mesChantiers,
    richessesHumaines,
    santeSecurite
} from '@design-system';
import './DesignSystemPage.scss';

import { useState } from 'react';

export const DesignSystemPage = () => {
    const [inputValue, setInputValue] = useState<string>('');
    const [passwordValue, setPasswordValue] = useState<string>('');

    return (
        <Container className="design-system-page">
            {['h1', 'h2', 'h3', 'h4', 'h5'].map((i) => (
                <Typography intrinsic={i as TypographyProps['intrinsic']} key={i}>
                    Titre {i}
                </Typography>
            ))}

            <div style={{ width: '100%', height: '15px' }}></div>

            {['h1', 'h2'].map((i) => (
                <Typography intrinsic={i as TypographyProps['intrinsic']} key={i} variant="sub">
                    Sous-titre {i}
                </Typography>
            ))}

            <div style={{ width: '100%', height: '15px' }}></div>

            {['p'].map((i) => (
                <Typography intrinsic={i as TypographyProps['intrinsic']} key={i}>
                    Texte 1
                </Typography>
            ))}

            <div style={{ width: '100%', height: '15px' }}></div>

            {['p'].map((i) => (
                <Typography intrinsic={i as TypographyProps['intrinsic']} key={i} variant="sub">
                    Texte info 1
                </Typography>
            ))}

            <div style={{ width: '100%', height: '30px' }}></div>

            <Typography intrinsic="h2">Buttons</Typography>

            <div style={{ width: '100%', height: '15px' }}></div>

            <div className="buttons-container">
                <div className="button-row">
                    <Typography intrinsic="h4">Primary Buttons</Typography>
                    <div className="button-group">
                        {['marine'].map((color) => (
                            <Button key={color} color={color as 'marine'} variant="primary">
                                <Typography intrinsic="h4">Button {color}</Typography>
                            </Button>
                        ))}
                    </div>
                </div>

                <div className="button-row">
                    <Typography intrinsic="h4">Secondary Buttons</Typography>
                    <div className="button-group">
                        {['green'].map((color) => (
                            <Button key={color} color={color as 'green'} variant="secondary">
                                <Typography intrinsic="h4">Button {color}</Typography>
                            </Button>
                        ))}
                    </div>
                </div>

                <div className="button-row">
                    <Typography intrinsic="h4">Tertiary Buttons</Typography>
                    <div className="button-group">
                        {['marine', 'grey'].map((color) => (
                            <Button key={color} color={color as 'marine' | 'grey'} variant="tertiary">
                                <Typography intrinsic="h4">Button {color}</Typography>
                            </Button>
                        ))}
                    </div>
                </div>

                <div className="button-row">
                    <Typography intrinsic="h4">Full Width Buttons</Typography>
                    <div className="button-group">
                        <Button color="marine" variant="primary" size="fullwidth">
                            <Typography intrinsic="h4">Full Width Button</Typography>
                        </Button>
                    </div>
                </div>
            </div>

            <div style={{ width: '100%', height: '30px' }}></div>

            <Typography intrinsic="h2">Custom Icons</Typography>
            {[mesChantiers, richessesHumaines, santeSecurite].map((icon) => (
                <CustomIcon src={icon} alt="Custom Icon" className="mr-medium-spacing" />
            ))}

            <div style={{ width: '100%', height: '30px' }}></div>

            <Typography intrinsic="h2">Inputs</Typography>

            <div style={{ width: '100%', height: '15px' }}></div>

            <Input label="Input simple" placeholder="Input simple" value={inputValue} onValueChange={setInputValue} />

            <Input
                label="Input mot de passe"
                placeholder="Input mot de passe"
                value={passwordValue}
                onValueChange={setPasswordValue}
                isPassword={true}
            />

            <div style={{ width: '100%', height: '30px' }}></div>

            <Typography intrinsic="h2">Separators</Typography>

            <div style={{ width: '100%', height: '15px' }}></div>

            <Separator />

            <Container>
                <Separator />
            </Container>

            <div style={{ width: '100%', height: '30px' }}></div>

            <Typography intrinsic="h2">Containers</Typography>

            <div style={{ width: '100%', height: '15px' }}></div>

            <Container style={{ backgroundColor: '#e6f5ed' }}>
                <Typography intrinsic="h4">Container</Typography>
            </Container>

            <div style={{ width: '100%', height: '30px' }}></div>

            {/* <Typography intrinsic="h2">Modals</Typography>

            <div style={{ width: "100%", height: "15px" }}></div>

            <Modal open={true} setClose={() => {}} title="Modal">
                <Typography intrinsic="h4">Modal</Typography>
            </Modal> */}
        </Container>
    );
};
